import { Webgl } from './Webgl';

export function createWebglModules(app) {
  return new Webgl(app);
}
